// Shared Constants
export const BASE_CHART_URL = "https://aaps.space/draw-kundli/testtubechart.php";

export const CHART_TYPES = {
  BIRTH: 'birth',
  YEAR: 'year',
  DAY: 'day',
  TRANSIT: 'transit',
  MONTH: 'month'
};

export const LOADING_STATES = {
  BIRTH: 'birth',
  YEAR: 'year',
  DAY: 'day',
  TRANSIT: 'transit'
};


export const zodiacNames = {
    1: "Aries",
    2: "Taurus",
    3: "Gemini",
    4: "Cancer",
    5: "Leo",
    6: "Virgo",
    7: "Libra",
    8: "Scorpio",
    9: "Sagittarius",
    10: "Capricorn",
    11: "Aquarius",
    12: "Pisces",
};

// export const SOCKET_EVENTS = {
//   CLIENT_QUESTION: 'client:question',
//   ADMIN_QUESTION: 'ask:question',
//   CLIENT_QUESTION_RESPONSE: 'client:question:response',
//   ADMIN_QUESTION_RESPONSE: 'question:received',
//   CONNECTED: 'connected',
//   ERROR: 'error'
// };

export const SOCKET_EVENTS = {
  CLIENT_QUESTION: 'client:question',
  ADMIN_QUESTION: 'admin:question',
  CLIENT_QUESTION_RESPONSE: 'client:question:response',
  ADMIN_QUESTION_RESPONSE: 'admin:question:response',
  CONNECTED: 'connected',
  ERROR: 'error'
};